import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Stethoscope, ArrowRight } from 'lucide-react';

const STORAGE_KEY = 'tcube_announcement_dismissed_v2';

const AnnouncementBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem(STORAGE_KEY);
    if (!dismissed) setIsVisible(true);
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-blue-600 via-cyan-600 to-emerald-600 text-white shadow-md"
      data-testid="announcement-bar"
    >
      <div className="container mx-auto px-3 sm:px-6">
        <div className="flex items-center justify-center gap-2 sm:gap-3 py-2 text-center relative">
          <Stethoscope className="w-4 h-4 hidden sm:block flex-shrink-0" aria-hidden="true" />
          <Link
            to="/book-consultation?from=announcement-bar"
            className="flex items-center gap-1.5 hover:underline pr-8 sm:pr-0"
            data-testid="announcement-cta"
          >
            <span className="text-xs sm:text-sm font-medium">
              Limited consultation slots available. Book your free doctor consultation today
            </span>
            <ArrowRight className="w-3.5 h-3.5 flex-shrink-0" aria-hidden="true" />
          </Link>
          <button
            onClick={handleDismiss}
            aria-label="Dismiss announcement"
            data-testid="announcement-dismiss-btn"
            className="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded-full transition-colors"
          >
            <X className="w-4 h-4" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
